import { adUnitIds } from 'services/utils/adUnitsMap';

export const breakByOptions = [
    {
        id: 0,
        displayText: 'None',
        key: 'none',
        titleText: 'Break by None'
    },
    {
        id: 1,
        displayText: 'Ad Unit',
        key: 'adUnits',
        titleText: 'Break by Ad Unit'
    },
    {
        id: 2,
        displayText: 'Ad Source',
        key: 'adSource',
        titleText: 'Break by Ad Source'
    },
    {
        id: 3,
        displayText: 'App',
        key: 'app',
        titleText: 'Break by App'
    },
    {
        id: 4,
        displayText: 'Platform',
        key: 'os',
        titleText: 'Break by Platform'
    },
    {
        id: 5,
        displayText: 'Country',
        key: 'country',
        titleText: 'Break by Country'
    }
];

export const tabs = [
    adUnitIds.all,
    adUnitIds.rewardedVideo,
    adUnitIds.interstitial,
    adUnitIds.banner
];
